import { render, staticRenderFns } from "./areaview.vue?vue&type=template&id=a426f346&scoped=true"
import script from "./areaview.vue?vue&type=script&lang=js"
export * from "./areaview.vue?vue&type=script&lang=js"
import style0 from "./areaview.vue?vue&type=style&index=0&id=a426f346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a426f346",
  null
  
)

export default component.exports